import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-assets",
  "use": "icon-assets-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-assets\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><g transform=\"translate(3.5 4.5)\"><rect width=\"17\" height=\"6\" y=\"9\" stroke=\"currentColor\" stroke-width=\"1.5\" rx=\"1\" /><rect width=\"17\" height=\"6\" stroke=\"currentColor\" stroke-width=\"1.5\" rx=\"1\" /><circle cx=\"4\" cy=\"3\" r=\"1\" fill=\"currentColor\" /><circle cx=\"13\" cy=\"12\" r=\"1\" fill=\"currentColor\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol